var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDailyForecastIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 30V18.75M127.5 30V18.75",
    stroke: "white",
    strokeWidth: 11.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 108.75L78.75 97.5V127.5",
    stroke: "white",
    strokeWidth: 11.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M161.25 67.5H80.625M15 67.5H44.0625M97.5 120V105C97.5 103.011 98.2902 101.103 99.6967 99.6967C101.103 98.2902 103.011 97.5 105 97.5C106.989 97.5 108.897 98.2902 110.303 99.6967C111.71 101.103 112.5 103.011 112.5 105V120C112.5 121.989 111.71 123.897 110.303 125.303C108.897 126.71 106.989 127.5 105 127.5C103.011 127.5 101.103 126.71 99.6967 125.303C98.2902 123.897 97.5 121.989 97.5 120Z",
    stroke: "white",
    strokeWidth: 11.25,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105 165H75C46.7175 165 32.5725 165 23.79 156.21C15 147.427 15 133.282 15 105V90C15 61.7175 15 47.5725 23.79 38.79C32.5725 30 46.7175 30 75 30H105C133.282 30 147.427 30 156.21 38.79C165 47.5725 165 61.7175 165 90V105C165 133.282 165 147.427 156.21 156.21C151.312 161.115 144.75 163.283 135 164.235",
    stroke: "white",
    strokeWidth: 11.25,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyForecastIcon);
export default __webpack_public_path__ + "static/media/daily_forecast_icon.9d9a8caea9f4e191bb6c4feee22ee24c.svg";
export { ForwardRef as ReactComponent };